import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';

export interface FormInputProps {
    className?: any;
    help?: string;
    id: string,
    inputmode?: 'text' | 'none' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search' | undefined;
    invalid?: boolean,
    maxLength?: number,
    label: string;
    name: string;
    onChange: (v: string) => void;
    placeholder?: string;
    readOnly?: boolean;
    required?: boolean;
    type?: string;
    value: string | null | undefined;
}

export const FormInput: FunctionComponent<FormInputProps> = observer((p) =>
    <div className="form-group">
        <label
            htmlFor={p.id}>
            {p.label}
        </label>
        <input
            aria-invalid={p.invalid}
            autoComplete="off"
            className="form-control"
            id={p.id}
            inputMode={p.inputmode}
            name={p.name}
            maxLength={p.maxLength ?? 200}
            onChange={(e) => p.onChange(e.target.value)}
            placeholder={p.placeholder}
            readOnly={p.readOnly}
            required={p.required}
            type={p.type ? p.type : 'text'}
            value={p.value!}
        />
        {p.help && <p className="input-hint">{p.help}</p>}
    </div>
);
